/**
 * @typedef { import('../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 */

import {convertObjectToYearMonthPeriod} from '../time.js';

//-----------------------------------------------------------------------------

export class PayerQuartileRevenueReport {
  /**
   * @param {YearMonthPeriod} period
   * @param {number[]} payerQuartileRevenues
   */
  constructor(period, payerQuartileRevenues) {
    this._period = period;
    this._payerQuartileRevenues = payerQuartileRevenues;
  }

  getPeriod() {
    return this._period;
  }

  getPayerQuartileRevenues() {
    return this._payerQuartileRevenues;
  }

  getTotalRevenue() {
    let totalRevenue = 0;
    for(const quartileRevenue of this._payerQuartileRevenues) {
      totalRevenue += quartileRevenue;
    }
    return totalRevenue;
  }

  /**
   * @param {number} qurtileNumber 
   * @returns {number}
   */
  getPayerQuartileRevenue(qurtileNumber) {
    const qurtileIndex = qurtileNumber - 1;
    return this._payerQuartileRevenues[qurtileIndex];
  }

  /**
   * @param {number} qurtileNumber 
   * @returns {number}
   */
  getPayerQuartileRevenuePercent(qurtileNumber) {
    const quartileRevenue = this.getPayerQuartileRevenue(qurtileNumber);
    const totalRevenue = this.getTotalRevenue();
    return (quartileRevenue / totalRevenue) * 100;
  }
}

/**
 * @typedef {Object} ReportObject
 * @property {YearMonthPeriodObject} period
 * @property {number[]} payerQuartileRevenues
 */

/**
 * @param {ReportObject} reportObject 
 * @returns {?PayerQuartileRevenueReport}
 */
export function convertObjectToPayerQuartileRevenueReport(reportObject) {
  const period = convertObjectToYearMonthPeriod(reportObject.period);
  if(period === null) {
    return null;
  }

  const revenues = reportObject.payerQuartileRevenues;

  return new PayerQuartileRevenueReport(period, revenues);
}

/**
 * @param {PayerQuartileRevenueReport} report
 * @returns {string}
 */
export function convertPayerQuartileRevenueReportToString(report) {
  let str = "quartile,revenue,percent\n";

  const totalRevenue = report.getTotalRevenue();

  const q1Revenue        = report.getPayerQuartileRevenue(1);
  const q1RevenuePercent = report.getPayerQuartileRevenuePercent(1);
  const q2Revenue        = report.getPayerQuartileRevenue(2);
  const q2RevenuePercent = report.getPayerQuartileRevenuePercent(2);
  const q3Revenue        = report.getPayerQuartileRevenue(3);
  const q3RevenuePercent = report.getPayerQuartileRevenuePercent(3);
  const q4Revenue        = report.getPayerQuartileRevenue(4);
  const q4RevenuePercent = report.getPayerQuartileRevenuePercent(4);

  str += `top [0-25%],${q1Revenue},${q1RevenuePercent.toFixed(2)}%\n`;
  str += `   (25-50%],${q2Revenue},${q2RevenuePercent.toFixed(2)}%\n`;
  str += `   (50-75%],${q3Revenue},${q3RevenuePercent.toFixed(2)}%\n`;
  str += `  (75-100%],${q4Revenue},${q4RevenuePercent.toFixed(2)}%\n`;
  str += `      total,${totalRevenue},100%\n`;
  return str
}
